export const localStorageKeys = {
    activeChatCardId: "activeChatCardId",
    campaignFilter: "campaignFilter",
    numberFilter: "numberFilter",
    prevNumberFilter: "prevNumberFilter",
    prevCampaignFilter: "prevCampaignFilter",
    monthFilter: "monthFilter",
    hideTeamFilter: "hideTeamFilter",
    prevHideTeamFilter: "prevHideTeamFilter",
    prevMonthFilter: "prevMonthFilter",
    unreadMessages: "unreadMessages",
    smsCapableFilter: "smsCapableFilter",
    prevSmsCapableFilter: "prevSmsCapableFilter",
    selectedRepresentative: "selectedRepresentative",
    prevSelectedRepresentative: "prevSelectedRepresentative",

    accessToken: "accessToken",
    metadataUrl: "metadataUrl",
    userMetadata: "userMetadata",
    outboundNumbers: "outboundNumbers"
};

export const windowBreakpoints = {
    tablet: 768,
    desktop: 1024,
    desktopLarge: 1200,
};

export const cookieKeys = {
    activeTime: "active_time",
};
